import { render, staticRenderFns } from "./grade-info.vue?vue&type=template&id=e5f35046&scoped=true&lang=pug"
import script from "./grade-info.vue?vue&type=script&lang=js"
export * from "./grade-info.vue?vue&type=script&lang=js"
import style0 from "./grade-info.vue?vue&type=style&index=0&id=e5f35046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f35046",
  null
  
)

export default component.exports